module.exports = __webpack_public_path__ + "img/hiper.e2a6254e.png";